/* tslint:disable */
/* eslint-disable */
/**
 * Bonds API
 * Microservice backend for bond management
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InvestorDashboard } from './InvestorDashboard';
import {
    InvestorDashboardFromJSON,
    InvestorDashboardFromJSONTyped,
    InvestorDashboardToJSON,
} from './InvestorDashboard';
import type { IssueDashboard } from './IssueDashboard';
import {
    IssueDashboardFromJSON,
    IssueDashboardFromJSONTyped,
    IssueDashboardToJSON,
} from './IssueDashboard';
import type { OrderStateEnum } from './OrderStateEnum';
import {
    OrderStateEnumFromJSON,
    OrderStateEnumFromJSONTyped,
    OrderStateEnumToJSON,
} from './OrderStateEnum';

import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
dayjs.extend(utc);
dayjs.extend(timezone);
/**
 * 
 * @export
 * @interface OrderDashboard
 */
export interface OrderDashboard {
    /**
     * 
     * @type {number}
     * @memberof OrderDashboard
     */
    readonly id: number;
    /**
     * 
     * @type {number}
     * @memberof OrderDashboard
     */
    amount: number;
    /**
     * 
     * @type {number}
     * @memberof OrderDashboard
     */
    readonly value: number;
    /**
     * 
     * @type {OrderStateEnum}
     * @memberof OrderDashboard
     */
    readonly state: OrderStateEnum;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof OrderDashboard
     */
    readonly validationResult: { [key: string]: any; };
    /**
     * 
     * @type {InvestorDashboard}
     * @memberof OrderDashboard
     */
    readonly investor: InvestorDashboard;
    /**
     * 
     * @type {IssueDashboard}
     * @memberof OrderDashboard
     */
    readonly issue: IssueDashboard;
    /**
     * 
     * @type {Date}
     * @memberof OrderDashboard
     */
    readonly orderCreatedAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof OrderDashboard
     */
    documentsSent?: Date;
    /**
     * 
     * @type {Date}
     * @memberof OrderDashboard
     */
    readonly activationDate: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof OrderDashboard
     */
    bondsSent?: Date;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof OrderDashboard
     */
    readonly validationTimeline: { [key: string]: any; };
}

/**
 * Check if a given object implements the OrderDashboard interface.
 */
export function instanceOfOrderDashboard(value: object): boolean {
    if (!('id' in value)) return false;
    if (!('amount' in value)) return false;
    if (!('value' in value)) return false;
    if (!('state' in value)) return false;
    if (!('validationResult' in value)) return false;
    if (!('investor' in value)) return false;
    if (!('issue' in value)) return false;
    if (!('orderCreatedAt' in value)) return false;
    if (!('activationDate' in value)) return false;
    if (!('validationTimeline' in value)) return false;
    return true;
}

export function OrderDashboardFromJSON(json: any): OrderDashboard {
    return OrderDashboardFromJSONTyped(json, false);
}

export function OrderDashboardFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderDashboard {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'amount': json['amount'],
        'value': json['value'],
        'state': OrderStateEnumFromJSON(json['state']),
        'validationResult': json['validation_result'],
        'investor': InvestorDashboardFromJSON(json['investor']),
        'issue': IssueDashboardFromJSON(json['issue']),
        'orderCreatedAt': (dayjs(json['order_created_at']).toDate()),
        'documentsSent': json['documents_sent'] == null ? undefined : (dayjs(json['documents_sent']).toDate()),
        'activationDate': (json['activation_date'] == null ? null : dayjs.tz(json['activation_date'], 'YYYY-MM-DD', dayjs.tz.guess()).toDate()),
        'bondsSent': json['bonds_sent'] == null ? undefined : (dayjs.tz(json['bonds_sent'], 'YYYY-MM-DD', dayjs.tz.guess()).toDate()),
        'validationTimeline': json['validation_timeline'],
    };
}

export function OrderDashboardToJSON(value?: OrderDashboard | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'amount': value['amount'],
        'documents_sent': value['documentsSent'] == null ? undefined : (dayjs(value['documentsSent'] as any).toISOString()),
        'bonds_sent': value['bondsSent'] == null ? undefined : (dayjs(value['bondsSent'] as any).format('YYYY-MM-DD')),
    };
}

